<template>
  <v-app id="login" class="primary">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>

          <v-flex v-if="companies.length <= 0" xs12 sm8 md4 lg4>
            <v-card class="elevation-1 pa-3">
              <v-card-text>
                <div class="layout column align-center">
                  <img src="/static/logo.png" width="120" height="120">
                  <h1 class="flex my-4 primary--text">Asistencia Mobile</h1>
                </div>
                <v-form>
                  <v-text-field append-icon="person" v-on:keyup.enter="loginSimple" name="login" label="Login" type="text" v-model="model.username"></v-text-field>
                  <v-text-field append-icon="lock" v-on:keyup.enter="loginSimple" name="password" label="Password" id="password" type="password" v-model="model.password"></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn block color="primary" @click="loginSimple" :loading="loading">Ingresar</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>

          <v-flex v-if="companies.length > 0" xs12 sm8 md4 lg4>
            <v-card class="elevation-1 pa-3">
              <v-card-text>
                <div class="layout column align-center">
                  <h1 class="flex my-4 primary--text">Asistencia Mobile</h1>
                </div>
                <v-select v-model="selectedCompanyRut" :items="companies" item-text="companyName" item-value="companyRut" label="Empresa" hide-details></v-select>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn block color="primary" :loading="loading" @click="btnNext">Continuar</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>


        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import axios from 'axios';



export default {
  data: () => ({
    loading: false,
    model: {
      username: '',
      password: ''
    },
    companies : [],
    selectedCompanyRut : null,
  }),
  watch: {
    'selectedCompanyRut' : function(val){
      if(val){
        let obj = this.companies.find(obj => obj.companyRut == val);
        localStorage.removeItem('ipApiServer');
        localStorage.setItem('ipApiServer', obj.ipApiServer+"/api/");
        localStorage.setItem('defaultCompanyRut', obj.companyRut);
      }
    }
  },
  mounted () {
    axios.defaults.baseURL = 'https://auth.asistenciamobile.cl/api/';
    localStorage.removeItem('token');
  },
  methods: {
    loginSimple () {
      this.loading = true;
      let router = this.$router;
      let model = this.model;

      let $this = this;

      axios.post('admin/login',{ email: model.username, password: model.password })
           .then(function(response){
              let token = response.data.token; //obtenemos el token
              localStorage.setItem('token', token);
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
              $this.getCompanies();
              // window.getApp.$emit('APP_LOGIN_SUCCESS'); //llamamos al evento APP_LOGIN_SUCCESS
            }).catch(error => {
              window.getApp.$emit('APP_LOGIN_FAILED');  //llamamos al evento APP_LOGIN_FAILED
            }).finally(function(){
              $this.loading = false;
            });
    },
    getCompanies(){
      let $this = this;
      axios.get('admin/login/getCompanies')
           .then(function(response){
              $this.companies = response.data;
              // console.log($this.companies);
            }).catch(error => {
              // window.getApp.$emit('APP_LOGIN_FAILED');  //llamamos al evento APP_LOGIN_FAILED
            });
    },
    btnNext(){
      window.getApp.$emit('APP_LOGIN_SUCCESS');
    }
  }

};
</script>
<style scoped lang="css">
  #login {
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
  }
</style>
